
export const CampaignCostDashboardPermissions = {
  CampaignCostDashboardPermissions: {
    permissionsId:'b7a132a6-5285-4795-f944-08dc0f48c1d2',
    permissionsName:'Campaign Cost Dashboard',
    componentsId:null,
    components:null
  }
  } ; 